import React from 'react';
import * as antd from 'antd';

const ModalContext = React.createContext();

class ModalProvider extends React.Component {
  state = { modal: null };

  render() {
    return (
      <ModalContext.Provider
        value={{
          setModal: this.setModal,
        }}
      >
        <antd.Modal
          open={this.state.modal !== null}
          onOk={() => this.setModal(null)}
          onCancel={() => this.setModal(null)}
          footer={null}
          closable={false}
        >
          {this.state.modal}
        </antd.Modal>

        {this.props.children}
      </ModalContext.Provider>
    );
  }

  setModal = (modal) => {
    this.setState({ modal });
  };
}

export { ModalContext, ModalProvider };
